const API_URL = '/api/prices.php';

const parseJson = async (response) => {
  const text = await response.text();
  if (!text) {
    return {};
  }
  try {
    return JSON.parse(text);
  } catch (error) {
    throw new Error('Invalid server response.');
  }
};

export const fetchPriceOverrides = async () => {
  const response = await fetch(API_URL, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Unable to load price overrides.');
  }

  const payload = await parseJson(response);
  return payload.overrides || {};
};

export const savePriceOverridesApi = async (overrides) => {
  const response = await fetch(API_URL, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ overrides }),
  });

  if (!response.ok) {
    throw new Error('Unable to save price overrides.');
  }

  return parseJson(response);
};
